import styles from './Initials.module.scss';

const Initials = ({ context }) => {
  // Build a case-insensitive pattern like [Jj][Dd] from "jd"
  const pattern = context.initials
    .split('')
    .map(c => `[${c.toUpperCase()}${c.toLowerCase()}]`)
    .join('');

  return (
    <span className={styles.root}>
      <input
        type='text'
        aria-label='initials'
        placeholder='Initials'
        pattern={`^${pattern}$`}
        required={true}
      />
    </span>
  );
};

export default Initials;